import { formatCryptoAmount } from '../formatCryptoAmount';
import { formatFiatAmount } from '../formatFiatAmount';
export const formatCryptoAndFiatAmount = ({ crypto, fiat, locale, }) => {
    return `${formatCryptoAmount({
        locale,
        amount: crypto.amount,
        symbol: crypto.symbol,
    })} (~${formatFiatAmount({
        locale,
        amount: fiat.amount,
        currency: fiat.currency,
    })})`;
};
